import React, { useContext, useState } from 'react'
import { getCurrentDepartment, getToggledTheme, updateThemeColors } from '../services/functions'

export const ThemesContext = React.createContext({})

function ThemesProvider({ children }) {
  const storageTheme = localStorage.getItem('theme')
  const [theme, setTheme] = useState(storageTheme)

  const toggleTheme = (themeValue) => {
    const theme = themeValue ?? getToggledTheme()
    localStorage.setItem('theme', theme.toString())
    window.dispatchEvent(new Event('storage'))
    setTheme(theme)
  }

  updateThemeColors()
  // console.log('ThemeProvider theme:', getCurrentDepartment())
  return (
    <ThemesContext.Provider value={{ toggleTheme, theme, setTheme }}>
      {children}
    </ThemesContext.Provider>
  )
}

function useThemes() {
  const context = useContext(ThemesContext)
  if (!context) {
    throw new Error('useThemes must be used within an ThemesProvider')
  }
  return context
}

export { useThemes, ThemesProvider }
